import {Completable, pending, QueueDTO, UnderwritingContext} from 'kashable-mobile-common';

import {fetchQueues as fetchQueuesRequest} from '../apis/queue';
import {RootState} from '../store';

import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

const INITIAL_STATE: Completable<Array<QueueDTO>> = pending();

export const fetchQueues = createAsyncThunk('queue/fetch', async (uec: UnderwritingContext | undefined, {rejectWithValue}) => {
    const response = await fetchQueuesRequest(uec);

    if (response.error) {
        rejectWithValue(response);
    }

    return response;
});

export const queueSlice = createSlice({
    name: 'queue',
    initialState: INITIAL_STATE,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        resetQueues: (state) => {
            if(state.value){
                return INITIAL_STATE;
            }

            return state;
        },
        clearQueues: () => {
            return {...INITIAL_STATE};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchQueues.pending, () => {
                return pending();
            })
            .addCase(fetchQueues.fulfilled, (state, action) => {
                return action.payload;
            });
    },
});

export const selectQueue = (state: RootState) => state.queue;
export const {
    resetQueues,
    clearQueues,
} = queueSlice.actions;
export default queueSlice.reducer;
